export interface SubGroupMapping {
  subGroupName: string;
  displayName: string;
}

export enum SubGroupName {
  TINTED_GLASS = 'External - Tinted Glass',
  EXTERNAL= 'External (Pick List)',
  INTERIOR_AC = 'Interior - A/C',
  INTERIOR_AIR_BAGS = 'Interior - Air Bags (Pick List)',
  INTERIOR_AUDIO = 'Interior - Audio (Pick List)',
  INTERIOR_POWER_DOORS = 'Interior - Power Door(s)',
  INTERIOR_POWER_LOCKS = 'Interior - Power Locks',
  INTERIOR_POWER_WINDOWS = 'Interior - Power Windows',
  INTERIOR_SEATING = 'Interior - Seating (Pick List)',
  INTERIOR = 'Interior (Pick List)',
  MECHANICAL_STEERING = 'Mechanical - Steering',
  MECHANICAL = 'Mechanical (Pick List)',
  WHEELS = 'External - Wheels',
  ROOF = 'External - Roof',
  BRAKES = 'Mechanical - Brakes',
  ABS = 'Mechanical - ABS',
  INDUCTION = 'Mechanical - Induction',
  TRANSMISSION = 'Mechanical - Tranmission Type',
  RATIO = 'Mechanical - Rear Axle Ratio'
}

export const subGroupMappings: SubGroupMapping[] = [
  {
    subGroupName: SubGroupName.TINTED_GLASS,
    displayName: 'Tinted Glass'
  },
  {
    subGroupName: SubGroupName.EXTERNAL,
    displayName: 'Miscellaneous'
  },
  {
    subGroupName: SubGroupName.INTERIOR_AC,
    displayName: 'A/C'
  },
  {
    subGroupName: SubGroupName.INTERIOR_AIR_BAGS,
    displayName: 'Airbags'
  },
  {
    subGroupName: SubGroupName.INTERIOR_AUDIO,
    displayName: 'Audio'
  },
  {
    subGroupName: SubGroupName.INTERIOR_POWER_DOORS,
    displayName: 'Power Doors'
  },
  {
    subGroupName: SubGroupName.INTERIOR_POWER_LOCKS,
    displayName: 'Power Locks'
  },
  {
    subGroupName: SubGroupName.INTERIOR_POWER_WINDOWS,
    displayName: 'Power Windows'
  },
  {
    subGroupName: SubGroupName.INTERIOR_SEATING,
    displayName: 'Seat'
  },
  {
    subGroupName: SubGroupName.INTERIOR,
    displayName: 'Miscellaneous'
  },
  {
    subGroupName: SubGroupName.MECHANICAL_STEERING,
    displayName: 'Steering'
  },
  {
    subGroupName: SubGroupName.MECHANICAL,
    displayName: 'Miscellaneous'
  },
  {
    subGroupName: SubGroupName.WHEELS,
    displayName: 'Wheels'
  },
  {
    subGroupName: SubGroupName.ROOF,
    displayName: 'Roof'
  },
  {
    subGroupName: SubGroupName.BRAKES,
    displayName: 'Brakes'
  },
  {
    subGroupName: SubGroupName.ABS,
    displayName: 'ABS'
  },
  {
    subGroupName: SubGroupName.INDUCTION,
    displayName: 'Induction'
  },
  {
    subGroupName: SubGroupName.TRANSMISSION,
    displayName: 'Transmission'
  },
  {
    subGroupName: SubGroupName.RATIO,
    displayName: 'Rear Axle Ratio'
  },
];

export enum SubGroupResponseName {
  WHEELS = 'wheels',
  ROOFS = 'roofs',
  BRAKES = 'brakes',
  ABS = 'absOptions',
  INDUCTION = 'inductionOptions',
  TRANSMISSION = 'transmissionOptions',
}
